// cms module: usp leiste - eigentlich nur einmal ganz oben auf der seite vorhanden
import Splide from '@splidejs/splide';

export class FeatureSlider {
    private featureSliders: NodeListOf<HTMLElement>;

    constructor() {
        this.featureSliders = document.querySelectorAll<HTMLElement>('#featuresSlider.splide');

        // Falls keine Slider gefunden werden, gibt es eine Nachricht in der Konsole aus
        if (this.featureSliders.length > 0) {
            this.initializeSliders();
        }
    }

    private initializeSliders(): void {

        this.featureSliders.forEach((sliderElement) => {

            let intervall = Number(sliderElement.dataset.intervalspeed);
            if (isNaN(intervall) || intervall <= 0) {
                intervall = 10000;
            }

            new Splide(sliderElement as HTMLElement, { // Typisierung fuer TypeScript
                type: 'loop',
                speed: 500,
                perPage: 4,
                perMove: 4,
                gap: 15,
                rewind: true,
                width: '100%',
                pagination: false,
                arrows: false,
                interval: intervall,
                autoplay: true,
                breakpoints: {
                    767: {
                        perPage: 2,
                        perMove: 2,
                    },
                },
            }).mount();
        });
    }
}

